import Lang from '/@/modules/core/app/services/Lang';
import { IncomeType } from '/@/modules/asset/enums/IncomeType';

export class IncomeAssetMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {boolean}
   */
  isConfirmed;

  constructor(model = {}) {
    this.type = model.type;
    this.isConfirmed = model.isConfirmed;
  }

  /**
   * @returns {boolean}
   */
  get isRental() {
    return this.type === IncomeType.RENTAL.key;
  }

  /**
   * @returns {boolean}
   */
  get isInterest() {
    return this.type === IncomeType.INTEREST.key;
  }

  /**
   * @returns {boolean}
   */
  get isDividend() {
    return this.type === IncomeType.DIVIDEND.key;
  }

  /**
   * @returns {string}
   */
  get displayDescription() {
    switch (this.type) {
      case IncomeType.DIVIDEND.key:
        return Lang.t('asset.paid-corporation-the');
      case IncomeType.INTEREST.key:
        return Lang.t(
          'asset.generated-accounts-that'
        );
      case IncomeType.RENTAL.key:
        return Lang.t('asset.income-earned-owned');
      case IncomeType.TAX_REFUND.key:
        return Lang.t('asset.income-from-tax');
      default:
        return '';
    }
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return IncomeType.getByKey(this.type).value;
  }
}
